import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
	{
		path: '/payment-plan/:customerNumber/:authToken',
		name: 'PaymentPlan',
		component: () => import('../views/PaymentPlan.vue'),
	},
	{
		path: '/quickpay',
		name: 'QuickPay',
		component: () => import('../views/QuickPay.vue'),
	},
	{
		path: '/make-payment',
		name: 'MakePayment',
		component: () =>
			import(/* webpackChunkName: "fetch-data" */ '../views/MakePayment.vue'),
	},
	{
		path: '/reverse-payment/:externalKeyType/:externalKeyValue/:authToken',
		name: 'ReversePayment',
		component: () =>
			import(/* webpackChunkName: "fetch-data" */ '../views/ReversePayment.vue'),
	},
	{
		path: '/payment-methods',
		name: 'EditPaymentMethods',
		component: () =>
			import(/* webpackChunkName: "fetch-data" */ '../views/EditPaymentMethods.vue'),
	},
    {
		path: '/donation/:accountType/:accountNumber/:amount/:zipCode',
        name: 'DonationWithAccountNumber',
        component: () =>
            import(/* webpackChunkName: "fetch-data" */ '../views/Donation.vue'),
	},
    {
		path: '/donation/:accountType/:donorName/:amount',
        name: 'DonationWithoutAccountNumber',
		component: () => import(/* webpackChunkName: "fetch-data" */ '../views/Donation.vue'),
	},
	{
		path: '/bluenet/payment/:aNumber/:customerNumber/:authToken',
		name: 'Bluenet',
		component: () => import(/* webpackChunkName: "fetch-data" */ '../views/Bluenet.vue'),
	},
	{
		path: '/bluenet/paymentmethods/:aNumber/:customerNumber/:authToken',
		name: 'Bluenet',
		component: () => import(/* webpackChunkName: "fetch-data" */ '../views/BluenetPaymentMethods.vue'),
	},
	{
        path: '/bluenet/customerprotection/:aNumber/:customerNumber/:authToken',
        name: 'CustomerProtection',
        component: () => import(/* webpackChunkName: "fetch-data" */ '../views/CustomerProtection.vue'),
    },
	{
		path: '/post-adjustment',
		//path: '/post-adjustment/:authToken/:webToken',
		name: 'PostAdjustment',
		component: () => import('../views/PostAdjustment.vue'),
	},
	{
		path: '/post-charge',
		name: 'PostCharge',
		component: () => import('../views/PostCharge.vue'),
	},
	{
		path: '*',
		name: 'Redirect',
		component: () => import(/* webpackChunkName: "fetch-data" */ '../views/Redirect.vue'),
	},

];

const router = new VueRouter({
	mode: 'history',
	//base: process.env.BASE_URL,
	//base: process.env.APP_BASEPATH,
	base: "/paymentlobby",
	routes,
});

export default router;
